export default __webpack_public_path__ + "static/media/NLAlogo.ab49e007.png";